import React from 'react';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Chip,
  IconButton,
  TextField,
} from '@material-ui/core';
import { Settings as SettingsIcon } from '@material-ui/icons';
import { Pie } from 'react-chartjs-2';
import { loadTexts } from '../../../../config/texts';

const styles = theme => ({
  card: {
    width: 470,
  },
  chip: {
    margin: theme.spacing.unit * 0.5,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
});
const TEXT_KEY = "survey";

const colors = ['#5454B2', '#f44336', '#ffeb3b', '#673ab7', '#03a9f4', '#4caf50', '#e91e63',
  '#3f51b5', '#00bcd4', '#8bc34a', '#ff5722', '#ffc107', '#795548', '#607d8b',
  '#9c27b0', '#2196f3', '#009688', '#cddc39', '#ff9800', '#9e9e9e'];

class QuestionCard extends React.Component {
  state = {
    mode: 'display',
    editQuestion: this.props.question,
    addOption: '',
    editOptions: this.props.options,
    texts: loadTexts(TEXT_KEY, this.props.locale)
  };
  options = {
    maintainAspectRatio: false,
    responsive: false,
    legend: { position: 'left', labels: { boxWidth: 10 } },
  };

  _onClickSettings = () => this.setState({ mode: 'edit' });
  _onKeyPress = event => {
    if (event.key === 'Enter') {
      this._onAddOption();
    }
  };
  _onAddOption = () => {
    if (!this.state.addOption.trim()) return;
    this.setState({
      addOption: '',
      editOptions: [...this.state.editOptions, this.state.addOption],
    });
  };
  _onDeleteOption = option => {
    this.setState(state => ({
      editOptions: state.editOptions.filter(opt => opt !== option),
    }));
  };
  _onCancel = () => {
    this.setState({
      mode: 'display',
      editQuestion: this.props.question,
      addOption: '',
      editOptions: this.props.options,
    });
  };
  _onUpdate = async () => {
    await this.props.onUpdate({
      _id: this.props.questionID,
      newQuestion: this.state.editQuestion,
      newOptions: this.state.editOptions,
    });
    this.setState({
      mode: 'display',
      editQuestion: this.props.question,
      addOption: '',
      editOptions: this.props.options,
    });
  };
  _onDelete = async () => {
    await this.props.onDelete({
      _id: this.props.questionID,
    });
  };

  render() {
    const { classes, question, labels, data } = this.props;
    const { mode, editQuestion, addOption, editOptions, texts } = this.state;
    const datasets = [{
      data,
      backgroundColor: colors,
      hoverBackgroundColor: colors,
    }];
    return (
      <Card className={classes.card}>
        {mode === 'display' && (
          <React.Fragment>
            <CardHeader
              title={question}
              action={(
                <IconButton onClick={this._onClickSettings}>
                  <SettingsIcon />
                </IconButton>
              )}
            />
            <CardContent>
              <Pie
                data={{ labels, datasets }}
                options={this.options}
                height={200}
                width={450}
              />
            </CardContent>
          </React.Fragment>
        )}
        {mode === 'edit' && (
          <React.Fragment>
            <CardContent>
              <TextField
                id="edit_question"
                label={texts.label.question}
                value={editQuestion}
                onChange={event => this.setState({ editQuestion: event.target.value })}
                fullWidth
              />
              <div>
                <TextField
                  id="add_option"
                  label={texts.label.add_option}
                  value={addOption}
                  onChange={event => this.setState({ addOption: event.target.value })}
                  onKeyPress={this._onKeyPress}
                />
                <Button onClick={this._onAddOption} color="primary">
                  {texts.button_text.add}
                </Button>
              </div>
              <div>
                {editOptions.map((option, i) => (
                  <Chip
                    key={i}
                    label={option}
                    onDelete={() => this._onDeleteOption(option)}
                    className={classes.chip}
                  />
                ))}
              </div>
            </CardContent>
            <CardActions className={classes.buttonContainer}>
              <Button color="secondary" onClick={this._onDelete}>
                {texts.button_text.delete}
              </Button>
              <div>
                <Button onClick={this._onCancel}>
                  {texts.button_text.cancel}
                </Button>
                <Button
                  disabled={!editQuestion || editOptions.length < 1
                    || editQuestion === question && isEqual(editOptions, this.props.options) }
                  onClick={this._onUpdate}
                  color="primary"
                >
                  {texts.button_text.update}
                </Button>
              </div>
            </CardActions>
          </React.Fragment>
        )}
      </Card>
    );
  }
}

QuestionCard.propTypes = {
  onUpdate: PropTypes.func,
  onDelete: PropTypes.func,
};

QuestionCard.defaultProps = {
  onUpdate: () => {},
  onDelete: () => {},
};

const mapStateToProps = state => ({
  locale: state.appState.locale,
});

export default compose(
  withStyles(styles, { name: 'QuestionCard' }),
  connect(mapStateToProps, {})
)(QuestionCard);



// WEBPACK FOOTER //
// ./src/modules/survey/cards/QuestionCard/index.js